<template>
  <v-card width="100%" style="border-radius: 12px; overflow: hidden">
    <v-form @submit.prevent="save" ref="form">
      <v-card-item>
        <v-card-title
        >{{
          viewType == "edit" ? "Edit" : viewType == "view" ? "View" : "Add"
        }}
        <b>Section</b>
      <v-btn
        @click="setFalse()"
        elevation="0"
        density="comfortable"
        icon="mdi-close"
        class="x-closeIcon"
      ></v-btn
    >
  </v-card-title>
   </v-card-item>

    <v-card-text>
        <v-row no-gutters class="mt-3 pa-2">
        <!-- Input Field -->

        <!-- <v-col cols="12" class="px-0 py-0" style="display: grid" v-if="formdata.id">
            <v-radio-group :disabled="showReadOnly" v-model="formdata.active" inline>
              <v-radio color="primary" label="Active" :value="1"></v-radio>
              <v-radio color="error" label="Inactive" :value="0"></v-radio>
            </v-radio-group>
          </v-col> -->
         <v-col cols="12">
          <v-label
            class="pb-1"
            style="font-size:14px;color:#272727;font-weight:600"
          >
            Status
          </v-label>

          <v-radio-group
            v-model="formdata.active"
            class="mr-4 d-flex flex-row justify-between"   
          >
            <v-radio color="primary" label="Active" :value="1" class="mr-4"></v-radio>
            <v-radio color="error" label="Inactive" :value="0"></v-radio>
          </v-radio-group>
        </v-col>



        <v-col cols="12">
           <v-label class="pb-1" style="font-size:14px;color:#272727;font-weight:600">Code
          <span  v-if="!showReadOnly" style="color:#CF0707;padding-left:2px;font-weight:700">*</span></v-label>
          <TextFieldComponent
            density="compact"
            placeholder="Code"
            :rules="domainRule"
            @keyup="checkDomain()" 
            v-model="formdata.code"
            :disabled="showReadOnly"
          />
        </v-col>

        <!-- Input Field -->

        <v-col cols="12">
           <v-label class="pb-1" style="font-size:14px;color:#272727;font-weight:600">Name
          <span  v-if="!showReadOnly" style="color:#CF0707;padding-left:2px;font-weight:700">*</span></v-label>
          <TextFieldComponent
            density="compact"
            placeholder="Name"
            :rules="displayNameRule"
            @keyup="checkDisplayValue()"
            v-model="formdata.name"
            :disabled="showReadOnly"
          />
        </v-col>

        <v-col cols="12"> 
           <v-label class="pb-1" style="font-size:14px;color:#272727;font-weight:600">SubCategory
          <span  v-if="!showReadOnly" style="color:#CF0707;padding-left:2px;font-weight:700">*</span></v-label>
          <AutoComplete
          placeholder="Subcategory "
              v-model="formdata.sub_category_id"
              item-value="id"
              item-title="name"
              :items="subCategoryData"
            />
        </v-col>
        
          </v-row>
      </v-card-text>
      <v-card-action class="mr-3">

        <!-- Cancle And Save Button -->

        <v-row justify="end" class="dialogBottom" v-if="!showReadOnly">
          <v-btn class="mr-2 cancel" @click="dialog = setFalse()">Cancel</v-btn>
          <v-btn class="save" type="submit">Save</v-btn>
        </v-row>
      </v-card-action>
    </v-form>
  </v-card>
</template>

<script>
import TextFieldComponent from "@/components/TextFieldComponent.vue";
// import SectionCategoriesService from "@/api/service/Enum/SectionCategoriesService";
import SectionCategoriesService from "@/api/service/SectionCategories/SectionCategoriesService";
import AutoComplete from "@/components/ui/AutoComplete.vue";
import SubCategoryService from "@/api/service/SubCategory/SubCategoryService";
export default {
  props: ["id", "viewType"],
  components: {
    TextFieldComponent,
    AutoComplete
  },

  data() {
    return {
        formdata: {
            active: 1,
      // showReadOnly: false,
            name:null,
            code:null,
            sub_category_id:null
      // domainRule: [(value) => !!value || "Domain is Required."],
      // displayNameRule: [(value) => !!value || "Display Name is Required."],
      // datavalueRule: [(value) => !!value || "Data Value is Required."],
      // dialog: false,
      // type: null,
      // formdata: {},
        },
              subCategoryData: [],

    };
  },

  watch: {
    id() {
      if (this.id) {
        this.formdata = {};
        this.getById(this.id);
      }
    },
  },

  created() {
    // this.getEnumData();
    this.getSubCategory()
    if (this.id) {
      this.getById(this.id);
    }
    if (this.viewType) {
      this.showReadOnly = this.viewType == "edit" ? false : true;
    }
  },

  methods: {
    // checkDisplayValue(){
    //   this.formdata.data_value = this.formdata.display_value?this.formdata.display_value.toLowerCase().split(' ').filter(Boolean).join(''):'';
    // },
    setFalse() {
      this.$emit("closeDialog");
    },
    async getById($id) {
      let res = await SectionCategoriesService.findOne({id:$id});
      this.formdata = res[0];
    },
    // async getEnumData() {
    //   let res = await SectionCategoriesService.findAll();
    //   this.enumData = res.length > 0 ? res : [];
    // },
    // checkDomain(){
    //   this.formdata.domain= this.formdata.domain?this.formdata.domain.toUpperCase():''
    // },
    async getSubCategory(){
        let res = await SubCategoryService.findAll({active:1});
        this.subCategoryData = res.length > 0 ? res:[]          
    },
    async save() {
        console.log(this.formdata,'formdataaaSC')
      let validation = await this.$refs.form.validate()
      if (!validation.valid) {
        console.log("Not valid")
      }
      else {
        if (this.formdata.id) {
          let output = await SectionCategoriesService.update(this.formdata);
          console.log(output,'output')
          this.dialog = false;
          this.setFalse();
          this.$emit("reload", true);
          this.formdata = [];
         
        } else {
          console.log(this.formdata,"frmmfrmm");
          let output = await SectionCategoriesService.create(this.formdata);
          console.log(output, "gfdgg");
          this.dialog = false;
          this.setFalse();
          this.$emit("reload", true);
          this.formdata = [];
        }
      }
    },
  },
};
</script>

<style>
.v-selection-control-group{
    flex-direction: row;
}
.v-selection-control {
    width: 100px;
}
</style>